module.exports = require('./helpers/bundle-url').getBundleURL('5Ddan') + "empty-state.d5f3bbe7.svg";